"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const functional_1 = require("./functional");
const xml_escape_1 = __importDefault(require("./xml-escape"));
const injectAttrs = (attrs) => functional_1.pipe.objToArr(attrs)((0, functional_1.reduce)((acc, [k, v]) => `${acc} ${k}="${(0, xml_escape_1.default)(v)}"`, ''));
const renderToXml = ({ model, modelId, onlyChanged, parentChangeable }) => {
    if (model[modelId] === undefined)
        return '';
    const { children = [], [constants_1.MODEL_TYPE]: type, [constants_1.MODEL_CONTENTS]: contents, changeable, 
    // Ignore meta, bindIndexes
    meta = {}, 
    // but add the rest of the attributes to the XML node
    ...attrs } = model[modelId];
    delete attrs.bindIndexes;
    const { initialValue } = meta;
    const { value = contents } = attrs;
    // if the node has no children, and its value hasn't changed,
    // then we can skip rendering it if we're only rendering changed nodes
    const nodeIsChangeable = changeable === undefined ? !!parentChangeable : changeable;
    if (nodeIsChangeable &&
        !children.length &&
        value === initialValue &&
        onlyChanged) {
        return '';
    }
    return `<${type}${injectAttrs(attrs)}>${(0, xml_escape_1.default)(contents)}${children
        .map((child) => renderToXml({
        model,
        modelId: child,
        onlyChanged,
        parentChangeable: nodeIsChangeable,
    }))
        .join('')}</${type}>`;
};
exports.default = renderToXml;
//# sourceMappingURL=render-to-xml.js.map